export const productShortName = 'Industrial Automation & PLC Systems — Professional Edition™';
export const productBrand = 'Industrial Automation & PLC Systems';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/27pNusaBzBUyJEFAkjqwcv/MOCKUP_4.57.27_p._m..png';

export const checkoutUrl = 'https://industrial-automation-plc-systems.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about PLC architecture and control logic',
  'No more uncertain technical explanations to colleagues',
  'No more struggling with sensor signals and I/O concepts',
  'No more gaps in understanding automation troubleshooting',
  "No more limited career advancement because technical knowledge isn't documented",
];
